import { selectProjects } from 'core/userContext/selectors';
import { useDispatch, useSelector } from 'react-redux';

import { SWITCH_PROJECTS_MODAL, WORKFLOW_DETAILS_MODAL } from '../../../constants';
import { closeModal, openModal } from '../../../ducks';
import { ClonedFromJourney } from '../../../types';
import { WORKFLOW_DETAILS_CLONE } from './WorkflowDetailsModal.constants';
import { DetailText, SwitchProjectLink } from './WorkflowDetailsModal.styled';

export const SwitchProjectsLink = ({ workflow }: { workflow: ClonedFromJourney }) => {
  const dispatch = useDispatch();
  const projects = useSelector(selectProjects) || [];
  const project = projects.find((p) => p.id === workflow?.projectId);

  const openSwitchProjectsModal = (args: ClonedFromJourney = {}) => {
    const { projectId, id: workflowId, workflowType } = args;

    dispatch(closeModal(WORKFLOW_DETAILS_MODAL));
    dispatch(
      openModal(SWITCH_PROJECTS_MODAL, {
        projectId,
        workflowId,
        workflowType,
      }),
    );
  };
  return (
    <DetailText data-test={WORKFLOW_DETAILS_CLONE}>
      {project ? (
        <>
          <SwitchProjectLink onClick={() => openSwitchProjectsModal(workflow)}>
            {workflow?.name}
          </SwitchProjectLink>
          <p>{project.name}</p>
        </>
      ) : (
        workflow?.name
      )}
    </DetailText>
  );
};
